import React from "react";
import PropTypes from "prop-types";
import { CheckboxField } from "@jutro/components";
import styles from "./ColumnEntry.module.css";
export function ColumnEntry(_ref) {
  var id = _ref.id,
    header = _ref.header,
    enabled = _ref.enabled,
    onToggle = _ref.onToggle;
  return header ? React.createElement("div", {
    className: styles.columnEntry
  }, React.createElement(CheckboxField, {
    id: id,
    label: header,
    controlClassName: styles.columnEntryCheckbox,
    labelClassName: styles.columnEntryLabel,
    value: enabled,
    showInlineLabel: !0,
    onValueChange: onToggle
  })) : null;
}
ColumnEntry.propTypes = {
  id: PropTypes.string.isRequired,
  header: PropTypes.string,
  enabled: PropTypes.bool,
  onToggle: PropTypes.func
}, ColumnEntry.__docgenInfo = {
  description: "ColumnEntry\n@param {object} param0",
  methods: [],
  displayName: "ColumnEntry",
  props: {
    id: {
      type: {
        name: "string"
      },
      required: !0,
      description: "Used to identify the component"
    },
    header: {
      type: {
        name: "string"
      },
      required: !1,
      description: "Label text to be displayed beside the checkbox"
    },
    enabled: {
      type: {
        name: "bool"
      },
      required: !1,
      description: "If true, the checkbox is marked as selected"
    },
    onToggle: {
      type: {
        name: "func"
      },
      required: !1,
      description: "Callback to toggle the checkbox enabled state"
    }
  }
}, ColumnEntry.__docgenInfo = {
  componentName: "ColumnEntry",
  packageName: "@jutro/datatable",
  description: "ColumnEntry",
  displayName: "ColumnEntry",
  methods: [],
  actualName: "ColumnEntry",
  props: {
    id: {
      type: {
        name: "string"
      },
      required: !0,
      description: "Used to identify the component"
    },
    header: {
      type: {
        name: "string"
      },
      required: !1,
      description: "Label text to be displayed beside the checkbox"
    },
    enabled: {
      type: {
        name: "bool"
      },
      required: !1,
      description: "If true, the checkbox is marked as selected"
    },
    onToggle: {
      type: {
        name: "func"
      },
      required: !1,
      description: "Callback to toggle the checkbox enabled state"
    }
  }
};